/* pp-menufix.js - moved out of sections/pp-menufix.liquid on 2026-09-05 (pp-lcp): this used to run inline in the header group,
   before the page content had even been parsed. As a deferred asset it runs after parsing and is cached across pages. */
(function(){
  var DUR=320,EASE='cubic-bezier(.3,.9,.3,1)';
  var reduce=false;try{reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  function wire(det){
    var sum=det.querySelector('summary'),wrap=det.querySelector('.dwrap');
    if(!sum||!wrap)return;
    sum.addEventListener('click',function(e){
      e.preventDefault();
      if(det.getAttribute('data-anim'))return;
      var opening=!det.open;
      if(reduce){det.open=opening;det.classList.toggle('exp',opening);return;}
      det.setAttribute('data-anim','1');
      var finished=false;
      function done(cb){
        function fin(ev){
          if(ev&&ev.propertyName&&ev.propertyName!=='height')return;
          if(finished)return;finished=true;
          wrap.removeEventListener('transitionend',fin);
          wrap.style.transition='';wrap.style.height='';
          cb();det.removeAttribute('data-anim');
        }
        wrap.addEventListener('transitionend',fin);
        setTimeout(fin,DUR+120);
      }
      if(opening){
        det.open=true;det.classList.add('exp');
        var h=wrap.scrollHeight;
        wrap.style.height='0px';wrap.getBoundingClientRect();
        wrap.style.transition='height '+DUR+'ms '+EASE;
        wrap.style.height=h+'px';
        done(function(){});
      }else{
        det.classList.remove('exp');
        var h2=wrap.scrollHeight;
        wrap.style.height=h2+'px';wrap.getBoundingClientRect();
        wrap.style.transition='height '+DUR+'ms '+EASE;
        wrap.style.height='0px';
        done(function(){det.open=false;});
      }
    });
  }
  function build(){
    try{
      var drawer=document.getElementById('drawer');
      var mega=document.getElementById('mega');
      if(!drawer||!mega||drawer.getAttribute('data-subs'))return;
      var MAP={
        '/collections/google-pixel-grapheneos':'grapheneos',
        '/collections/all-magisk-rooted-devices':'rooted',
        '/collections/all-ios-jailbreak':'jailbroken',
        '/products/magisk-root-installation-service':'rootsvc',
        '/blogs/free-rooting-tips-and-tricks':'guides'
      };
      var origs=[];
      for(var i=0;i<drawer.children.length;i++){
        var c=drawer.children[i];
        if(c.tagName==='A'&&!c.classList.contains('dcta'))origs.push(c);
      }
      origs.forEach(function(orig){
        var key=MAP[orig.getAttribute('href')];
        if(!key)return;
        var panel=mega.querySelector('.panel[data-panel="'+key+'"]');
        if(!panel)return;
        var cols=panel.querySelectorAll('.col');
        if(!cols.length)return;
        var det=document.createElement('details');
        det.className='macc';
        var sum=document.createElement('summary');
        sum.innerHTML=orig.innerHTML;
        det.appendChild(sum);
        var sub=document.createElement('div');
        sub.className='dsub';
        for(var j=0;j<cols.length;j++){
          var col=cols[j];
          var sh=col.querySelector('.sh');
          if(sh){var s=document.createElement('span');s.className='sh';s.textContent=sh.textContent;sub.appendChild(s);}
          var as=col.querySelectorAll('a[href]');
          for(var k=0;k<as.length;k++){
            var a=as[k];
            var na=document.createElement('a');
            na.setAttribute('href',a.getAttribute('href'));
            na.innerHTML=a.innerHTML;
            if(a.target)na.target=a.target;
            if(a.rel)na.rel=a.rel;
            sub.appendChild(na);
          }
        }
        var foot=panel.querySelector('.foot a');
        if(foot){
          var fa=document.createElement('a');
          fa.className='dall';
          fa.setAttribute('href',foot.getAttribute('href'));
          fa.innerHTML=foot.innerHTML;
          sub.appendChild(fa);
        }
        var wrap=document.createElement('div');
        wrap.className='dwrap';
        wrap.appendChild(sub);
        det.appendChild(wrap);
        wire(det);
        orig.parentNode.replaceChild(det,orig);
      });
      drawer.setAttribute('data-subs','1');
    }catch(e){}
  }
  function fixBadges(){
    try{
      var cards=document.querySelectorAll('.pp-land .tc');
      if(!cards.length)return;
      var A='stroke-linecap="round" stroke-linejoin="round"';
      var S='<svg fill="none" stroke="currentColor" stroke-width="1.7" viewBox="0 0 24 24">';
      var TRUCK=S+'<path '+A+' d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"/></svg>';
      var NOTE=S+'<path '+A+' d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"/></svg>';
      var LOCK=S+'<path '+A+' d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/></svg>';
      var CHAT=S+'<path '+A+' d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"/></svg>';
      var seq=[TRUCK,NOTE,LOCK,CHAT];
      for(var i=0;i<cards.length;i++){
        var tc=cards[i];
        var n=tc.querySelector('.n');
        if(!n)continue;
        var b=tc.querySelector('b');
        var t=(b?b.textContent:'').toLowerCase();
        var svg;
        if(/ship|deliver/.test(t))svg=TRUCK;
        else if(/money|refund|return|back|guarantee/.test(t))svg=NOTE;
        else if(/secure|checkout|payment|\bpay\b/.test(t))svg=LOCK;
        else if(/support|chat|help|24\/7/.test(t))svg=CHAT;
        else svg=seq[i]||TRUCK;
        var ic=document.createElement('span');
        ic.className='ic';
        ic.innerHTML=svg;
        n.parentNode.replaceChild(ic,n);
      }
    }catch(e){}
  }
  function init(){build();fixBadges();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
